import { FC, ReactElement, lazy, Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import { Layout } from '@/components';

const AddGovernance = lazy(() => import('@/page/AddGovernance'));
const GovernanceDetail = lazy(() => import('@/page/GovernanceDetail'));
const TeamDetails = lazy(() => import('@/page/teamDetails'));
const Home = lazy(() => import('@/page/Home'));
const SignUp = lazy(() => import('@/page/SignUp'));
const PlanDetail = lazy(() => import('@/page/PlanDetail'));
const NodeDetail = lazy(() => import('@/page/NodeDetail'));

const TabRoute: FC = (): ReactElement => {
    return (
        <Suspense fallback={<div></div>}>
            <Layout>
                <Switch>
                    <Route path="/report/detail" component={TeamDetails} />
                    <Route path="/report" component={Home} />
                    <Route path="/signup" component={SignUp} />
                    <Route path="/governance-add" component={AddGovernance} />
                    <Route path="/governance-detail" component={GovernanceDetail} />
                    <Route path="/node-detail" component={NodeDetail} />
                    <Route path="/plan-detail" component={PlanDetail} />
                </Switch>
            </Layout>
        </Suspense>
    );
};
export default TabRoute;
